export const DialogSizeEnum = {
    small: 680,
    medium: 900,
    large: 1200,
};
export const IconEnum = {
    success: 'https://img.alicdn.com/imgextra/i3/O1CN01nCD4nv1lnlCGNXI4L_!!6000000004864-2-tps-88-88.png',
    warning: 'https://img.alicdn.com/imgextra/i1/O1CN01LwtmYl1Y0DLOfh4EN_!!6000000002996-2-tps-88-82.png',
    about: 'https://img.alicdn.com/imgextra/i4/O1CN01zPprSm1o77ANqLkA0_!!6000000005177-2-tps-88-88.png',
    notice: 'https://img.alicdn.com/imgextra/i2/O1CN01O6IbrI1u2tCrAKX5S_!!6000000005980-2-tps-88-88.png',
};
